module.exports = __webpack_public_path__ + "img/insight.b399a2e1.svg";